import { Station, useIsMounted } from '@mi-front/core';
import { useReducer } from 'react';
import { useIntl } from 'react-intl';
import { Prompt } from 'react-router';
import { uploadFiles } from './actions';
import { UploadAction, initialState, viewReducer } from './reducer';
import { UploadViewP } from './view_p';

export function UploadAudioView(p: { station: Station }) {
  const [state, _dispatch] = useReducer(viewReducer, initialState);
  const isMounted = useIsMounted();
  const { $t } = useIntl();

  const anyUpload = !!state.uploads.length;
  const shouldPromptLeave =
    state.status === 'STARTED' || (state.status === 'NOT_STARTED' && anyUpload);

  const dispatch = (action: UploadAction) => {
    if (!isMounted.current) {
      return;
    }

    return _dispatch(action);
  };

  return (
    <div>
      <UploadViewP
        uploads={state.uploads}
        upload={
          state.status !== 'COMPLETED' && state.uploads.length
            ? () =>
                uploadFiles({
                  stationId: p.station.id,
                  files: state.uploads.map((u) => ({
                    file: u.file,
                    audioId: u.audioId,
                  })),
                  dispatch,
                })
            : null
        }
        add={
          !anyUpload && state.status === 'NOT_STARTED'
            ? (files) =>
                dispatch({
                  type: 'ALL_ADD',
                  payload: files,
                })
            : null
        }
        clearAll={
          (anyUpload && state.status === 'NOT_STARTED') || state.status === 'COMPLETED'
            ? () =>
                dispatch({
                  type: 'ALL_RESET',
                })
            : null
        }
        remove={(index) =>
          state.status === 'NOT_STARTED'
            ? dispatch({
                type: 'UPLOAD_REMOVE',
                payload: {
                  index,
                },
              })
            : null
        }
        updateId={(index, value) =>
          dispatch({
            type: 'UPLOAD_UPDATE_ID',
            payload: {
              index,
              value,
            },
          })
        }
      />
      <Prompt
        when={shouldPromptLeave}
        message={$t({
          id: 'audit.uploadScreen.leavePrompt',
          defaultMessage:
            'Uno o más archivos están siendo cargados. ¿Estás seguro que deseas abandonar la página?',
        })}
      />
    </div>
  );
}
